import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { IMAGE_TYPE } from "~/configs/constants";
import { isMobile } from '../../helpers/utils'

import {
  Button,
  ButtonGroup,
  Card,
  CardHeader,
  CardBody,
  Form,
  FormGroup,
  Input,
  Row,
  Col
} from "reactstrap";

function mountEvent(name,value) {
  return {
    target:{
      name: name,
      value: value,
    }
  };
}; 

const ImageComponent = ({
  onChange,
  onClick,
  onCancel,
  onFileChange,
  image,
  files
}) => {
  return (
    <Row>
      <Col>
        <Card>
          <CardHeader>
            <h5 className="title">Mídia</h5>
          </CardHeader>
          <CardBody>
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                onClick();
              }}
            >    
              {files && files.length > 0 && image?.type === IMAGE_TYPE.image && (
                <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", justifyContent: "flex-start", marginBottom: "10px" }}>
                  {files.map((file, index) => (
                    <div 
                      style={{
                          width: "150px",
                          border: "1px solid #ccc",
                          borderRadius: "4px"
                        }}
                        >
                      <img
                        key={index}
                        src={file.url}
                        alt={`preview-${index}`}                      
                      />
                      <div style={{ marginTop: "5px" }}>
                        {file.name}
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {files && files.length > 0 && image?.type === IMAGE_TYPE.video && (
                <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", justifyContent: "flex-start", marginBottom: "10px" }}>
                  {files.map((file, index) => (
                    <div 
                      style={{
                          width: "150px",
                          border: "1px solid #ccc",
                          borderRadius: "4px"
                        }}
                        >
                      <video
                        key={index}
                        src={file.url}
                        autoPlay 
                        muted 
                        playsInline
                        loop
                        style={{
                          width: "100%",
                          objectFit: "contain",
                          borderRadius: "4px"
                        }}
                      />
                      <div style={{ marginTop: "5px" }}>
                        {file.name}
                      </div>
                    </div>
                  ))}
                </div>
              )}
              <Row>                                                
                <Col xs={12} md={8}>
                  <FormGroup>
                    <span style={{marginBottom: "0px"}}>Tipo</span><br/>
                    <ButtonGroup style={{width: "100%"}}>
                      <Button style={{width: "50%", padding: isMobile() ? "0px" : "10px 22px"}} disabled={(image?.imageId > 0)} color="info" className={classNames("btn-simple", {active: image?.type === IMAGE_TYPE.image})} outline onClick={()=>onChange(mountEvent("type", 1))}>Imagem</Button>
                      <Button style={{width: "50%", padding: isMobile() ? "0px" : "10px 22px"}} disabled={(image?.imageId > 0)} color="info" className={classNames("btn-simple", {active: image?.type === IMAGE_TYPE.video})} outline onClick={()=>onChange(mountEvent("type", 2))}>Vídeo</Button>
                    </ButtonGroup>                        
                  </FormGroup>                     
                </Col> 
                <Col xs={12} md={4}>
                  <FormGroup>
                    <span>Tempo de exibição (em segundos)</span>
                    <Input
                      name="showTime"
                      type="number"
                      placeholder="Tempo de exibição"
                      value={image?.showTime}
                      onChange={(e) => onChange(e)}
                    />
                  </FormGroup>
                </Col>                               
              </Row>
              <Row>
                <Col xs={12} md={12}>
                {image?.type === IMAGE_TYPE.image ? <span>As extensões suportadas para imagens são: .JPEG .JPG .PNG .BMP .GIF</span>
                : <span>A extensão suportada para vídeos é: .MP4 ou .GIF </span>}
                  <div style={{marginBottom: "15px"}}>
                    <input id="uploadCaptureInputMidia" type="file" onChange={onFileChange} multiple={image?.imageId === 0}  />
                  </div>  
                </Col>
              </Row>
              <Row>     
                <Col style={{textAlign: "right"}}>
                  <Button
                    className="btn-fill btn-xs"
                    color="danger"
                    type="button"
                    onClick={()=>onCancel()}
                  >
                    Voltar
                  </Button>
                  <Button
                    className="btn-fill btn-xs"
                    color="primary"
                    type="submit"
                  >
                    Salvar
                  </Button>
                </Col>
              </Row>                  
            </Form>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

ImageComponent.propTypes = {
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  image: PropTypes.object.isRequired
};

export default ImageComponent;